import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const AgentCardEmailIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none" className={className} onClick={onClick}>
      <path d="M13.3333 1.33333C13.3333 0.6 12.7333 0 12 0H1.33333C0.6 0 0 0.6 0 1.33333V9.33333C0 10.0667 0.6 10.6667 1.33333 10.6667H12C12.7333 10.6667 13.3333 10.0667 13.3333 9.33333V1.33333ZM12 1.33333L6.66667 4.66667L1.33333 1.33333H12ZM12 9.33333H1.33333V2.66667L6.66667 6L12 2.66667V9.33333Z" fill="#323232"/>
    </svg>
  );
};

export default AgentCardEmailIcon;
